import TechnicalRepresentativeContainer from './TechnicalRepresentativeContainer';
export default TechnicalRepresentativeContainer;
